var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmixLogoSingle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 106,
    viewBox: "0 0 116 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8998 61.7999C21.6998 67.6999 27.8998 72.5999 34.7998 75.8999C31.5998 69.0999 29.7998 61.2999 29.7998 53.2999C29.7998 45.2999 29.7998 53.2999 29.7998 53.0999V51.2999C30.0998 43.5999 31.9998 36.3999 35.1998 29.8999C40.0998 19.8999 48.3998 12.1999 58.1998 6.9999C65.1998 3.2999 73.0998 0.799902 81.4998 0.599902C79.8998 0.199902 77.8998 -0.100098 76.1998 -0.100098H39.4998C37.7998 -0.100098 36.0998 0.0999024 34.3998 0.499902C28.7998 1.8999 23.9998 5.3999 21.0998 10.4999L5.7998 36.9999C6.6998 42.6999 8.5998 47.9999 11.1998 52.8999C12.7998 55.9999 14.3998 58.9999 16.5998 61.6999H16.7998L16.8998 61.7999Z",
    fill: "url(#paint0_linear_50_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9998 100.1C51.9998 103.3 44.8998 105.3 37.7998 106H78.0998C84.9998 105.4 91.1998 101.5 94.6998 95.4999L110.2 68.8999C109.3 63.1999 107.4 57.8999 104.8 52.9999C99.4998 42.9999 90.9998 34.7999 80.6998 29.8999C83.8998 36.4999 85.7998 43.6999 86.0998 51.2999V52.8999C86.0998 53.3999 86.0998 52.8999 86.0998 53.0999V53.2999C86.0998 61.2999 84.2998 68.9999 81.0998 75.7999",
    fill: "url(#paint1_linear_50_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0001 75.9C74.0001 79.3 66.2001 81.2 57.9001 81.2C49.6001 81.2 41.8001 79.3 34.8001 75.9C27.9001 72.5 21.8001 67.7 17.0001 61.8C14.8001 59.1 13.0001 56.2 11.3001 53.1C8.7001 48.2 6.8001 42.7 5.8001 37L2.7001 42.5C-1.0999 49.1 -1.0999 57.2 2.7001 63.8L5.7001 69.1L21.0001 95.6C24.5001 101.6 30.7001 105.5 37.6001 106.1H38.1001C45.2001 105.4 51.8001 103.4 57.8001 100.3C67.9001 95 76.0001 86.5 80.9001 76.1V75.9H81.0001Z",
    fill: "url(#paint2_linear_50_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1 42.4001L110.1 37.1001L94.8001 10.6001C91.9001 5.5001 87.0001 2.0001 81.5001 0.600098C73.1001 0.800098 65.1001 3.0001 58.1001 6.7001C48.3001 11.9001 40.0001 20.1001 35.1001 30.0001C42.0001 26.7001 50.0001 24.9001 58.1001 24.9001C66.2001 24.9001 73.9001 26.7001 80.8001 30.0001C91.1001 34.9001 99.5001 43.0001 104.8 53.0001C107.4 57.9001 109.2 63.2001 110.2 68.9001L113.2 63.7001C117 57.1001 116.9 49.0001 113.2 42.4001H113.1Z",
    fill: "url(#paint3_linear_50_382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_382",
    x1: 43.3998,
    y1: 18.6999,
    x2: 16.5998,
    y2: 62.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB2259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_50_382",
    x1: 109.9,
    y1: 40.9999,
    x2: 42.6998,
    y2: 108.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#194961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#307192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#55B2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64CCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_50_382",
    x1: 9.2001,
    y1: 56.3,
    x2: 62.1001,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_50_382",
    x1: 100.8,
    y1: 55.7001,
    x2: 48.8001,
    y2: 3.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#956FD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2E57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmixLogoSingle);
export default __webpack_public_path__ + "static/media/pmix-logo-single.75a8a96c96794e625664376aaeb0d7e2.svg";
export { ForwardRef as ReactComponent };